import { get, isEmpty, isEqual } from 'lodash';
import moment from 'moment';
import { storageTypes } from '../../constants/globals';
import { getItem, setItem } from '../../utils/storage';
import { differenceBetween } from '../../utils/fudrLocalizationHelper';
import orderingRoutes from '../../routes/ordering';
import rewardsRoutes from '../../routes/rewards';
import { isNativeWebView } from '../../utils/helpers';
import { nativeEventType } from '../../containers/Rewards/config';

export const handleLinkUrl = ({ linkUrl, context }) => {
  if (isNativeWebView) {
    const data = {
      shareType: { type: 'link-url', url: linkUrl, context },
    };
    window.ReactNativeWebView.postMessage(JSON.stringify(data));
  } else {
    window.open(linkUrl, '_blank');
  }
};

export const birthdayRewardAvailableDate = (dateOfBirth, months = 1, type = 'view') => {
  let startDate = isEqual(type, 'view')
    ? moment(dateOfBirth)
        .set('year', moment().get('year'))
        .subtract(months, 'months')
        .startOf('month')
    : moment(dateOfBirth).set('year', moment().get('year')).startOf('month');
  let endDate = moment(dateOfBirth).set('year', moment().get('year')).endOf('month');
  if (moment().isAfter(endDate)) {
    return { startDate: startDate.add(1, 'year'), endDate: endDate.add(1, 'year').endOf('month') };
  } else {
    return { startDate, endDate: endDate };
  }
};

export const anniversaryRewardAvailableDate = (dateOfanniversary, months = 1, type = 'view') => {
  let startDate = isEqual(type, 'view')
    ? moment(dateOfanniversary)
        .set('year', moment().get('year'))
        .subtract(months, 'months')
        .startOf('month')
    : moment(dateOfanniversary).set('year', moment().get('year')).startOf('month');
  let endDate = moment(dateOfanniversary).set('year', moment().get('year')).endOf('month');
  if (moment().isAfter(endDate)) {
    return { startDate: startDate.add(1, 'year'), endDate: endDate.add(1, 'year').endOf('month') };
  } else {
    return { startDate, endDate: endDate };
  }
};

export const checkIfBirthdayCouponNotSubscribed = (dateOfBirth, months = 1) => {
  let startDate = birthdayRewardAvailableDate(dateOfBirth, months).startDate;
  let endDate = birthdayRewardAvailableDate(dateOfBirth).endDate;
  if (moment().isAfter(startDate) && moment().isBefore(endDate) && !isEmpty(dateOfBirth)) {
    return true;
  }
};

export const checkIfAnniversaryCouponNotSubscribed = (dateOfanniversary, months = 1) => {
  let startDate = anniversaryRewardAvailableDate(dateOfanniversary, months).startDate;
  let endDate = anniversaryRewardAvailableDate(dateOfanniversary).endDate;
  if (moment().isAfter(startDate) && moment().isBefore(endDate) && !isEmpty(dateOfanniversary)) {
    return true;
  }
};

export const checkGuestFirstLogin = (rewardJoiningDate, brandGuestId) => {
  if (differenceBetween(moment(), rewardJoiningDate) > 0) {
    return false;
  } else if (
    isEqual(getItem(storageTypes.localStorage, 'isWelcomeMessageShown' + brandGuestId), true)
  ) {
    return false;
  } else {
    return true;
  }
};

export const checkIsGuestJoinedRewardPriorUpdate = ({ rewardJoiningDate, rewardUpdateDate }) => {
  const currentDate = moment().format();
  if (
    moment(rewardJoiningDate).isBefore(currentDate) &&
    moment(rewardJoiningDate).isBefore(rewardUpdateDate)
  ) {
    return true;
  } else {
    return false;
  }
};

export const renderList = (numberOfObjects) => {
  const list = [];
  for (let index = 0; index < numberOfObjects; index++) {
    list.push({});
  }
  return list;
};

export const handlePhoneNumber = ({ countryCode, phoneNumber }) => {
  if (window.ReactNativeWebView) {
    const data = {
      shareType: { type: 'mail', url: `tel:${phoneNumber}` },
    };
    window.ReactNativeWebView.postMessage(JSON.stringify(data));
  } else {
    window.open(`tel:${countryCode}${phoneNumber}`, '_self');
  }
};

export const getMappingSteps = (length) => {
  switch (length) {
    case 1:
      return [100];
    case 2:
      return [50, 100];
    case 3:
      return [33.6, 67.8, 100];
    default:
      return [25, 25, 25, 25];
  }
};

export const getOrderingRouteContext = (selectedTable) => {
  let scanCode = get(selectedTable, 'scanCode', '');
  if (!isEmpty(scanCode)) {
    return `/${rewardsRoutes.rewards}/${rewardsRoutes.containers.ordering}/${orderingRoutes.containers.menu}/${scanCode}`;
  } else {
    return `/${rewardsRoutes.rewards}/${rewardsRoutes.containers.ordering}`;
  }
};

export const extractDataFromNative = ({
  message,
  history,
  selectedTable,
  handleNativeBackCTA,
  handleLogout,
  handleNativeRouteName,
  handleClearViewCartItems,
  handleUpdateCart,
  handleRestaurantSelection,
}) => {
  let dataFromApp = get(message, 'data', '');
  if (!isEmpty(dataFromApp)) {
    dataFromApp = dataFromApp && JSON.parse(dataFromApp);
    const { eventType, data, payload = {} } = dataFromApp;
    switch (eventType) {
      case nativeEventType.nativeAppUpdateAvailable:
        setItem(storageTypes.sessionStorage, 'nativeAppUpdateAvailable', data);
        break;
      case nativeEventType.appVersion:
        data && setItem(storageTypes.sessionStorage, 'appVersion', data);
        break;
      case nativeEventType.location:
        const draftLocationCoordinates = {
          lat: get(data, 'coords.latitude'),
          lng: get(data, 'coords.longitude'),
        };

        setItem(storageTypes.localStorage, 'geoLocation', draftLocationCoordinates);
        window.dispatchEvent(new Event('NewLocationSet'));
        // Dispatching this event to listen location change wherever needed
        break;
      case nativeEventType.currentLocation:
        const locationCoordinates = {
          lat: get(data, 'coords.latitude'),
          lng: get(data, 'coords.longitude'),
        };

        window.dispatchEvent(
          new CustomEvent('DraftCurrentLocationSet', { detail: { locationCoordinates } }),
        );
        break;
      case nativeEventType.routeName:
        if (isEqual(data, orderingRoutes.ordering)) {
          let updatedRoute = getOrderingRouteContext(selectedTable);
          history.push(updatedRoute);
        } else {
          history.push(`/${rewardsRoutes.rewards}/${data}`, { payload });
        }
        break;
      case nativeEventType.hardwareBackPress:
        handleNativeBackCTA();
        break;
      case 'pagesInNative':
        setItem(storageTypes.localStorage, 'pagesInNative', data);
        break;
      case nativeEventType.canGoBack:
        setItem(storageTypes.localStorage, nativeEventType.canGoBack, data);
        break;
      case nativeEventType.canExitModule:
        setItem(storageTypes.localStorage, nativeEventType.canExitModule, data);
        break;
      case 'logout':
        handleLogout(data);
        break;
      case 'scrollToTop':
        if (window.pageYOffset > 0) {
          window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
          setTimeout(() => {
            if (window.pageYOffset > 0) {
              window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
            }
          }, 100);
        }
        break;
      case nativeEventType.nativeRouteName:
        handleNativeRouteName(data);
        break;
      case nativeEventType.clearCartAction:
        handleClearViewCartItems();
        break;
      case nativeEventType.updateMenuCart:
        handleUpdateCart(data);
        break;
      case nativeEventType.restaurantSelection:
        handleRestaurantSelection(data);
        break;
      default:
        break;
    }
  }
};

export const checkVIPFlowApplicable = ({ applicableBrandModules, isBetaUser }) => {
  let isVIPPassFlowApplicable = '';
  const isVIPFlowActive = get(
    applicableBrandModules.find((bModule) => bModule.code === 'pass'),
    'isActive',
    false,
  );

  const isVIPFlowActiveForBetaUsers = get(
    applicableBrandModules.find((bModule) => bModule.code === 'pass'),
    'isBeta',
    false,
  );
  if (isVIPFlowActive) {
    if (isVIPFlowActiveForBetaUsers) {
      if (isBetaUser) {
        isVIPPassFlowApplicable = true;
      } else {
        isVIPPassFlowApplicable = false;
      }
    } else {
      isVIPPassFlowApplicable = true;
    }
  } else {
    isVIPPassFlowApplicable = false;
  }
  return isVIPPassFlowApplicable;
};

export const renderCurrenyName = (currencyName) => {
  return !isEmpty(currencyName) ? currencyName.toUpperCase().split(' ').join('\n') : '';
};


export const checkBrandModuleApplicable = ({
  applicableBrandModules,
  moduleName,
}) => {
  let isModuleApplicable = false;
  const isModuleActive = get(
    applicableBrandModules.find((bModule) => bModule.code === moduleName),
    "isActive",
    false
  );
  const isModuleActiveBeta = get(
    applicableBrandModules.find((bModule) => bModule.code === moduleName),
    "isBeta",
    false
  );

  if (isModuleActive) {
    isModuleApplicable = true;
  } else if (isModuleActiveBeta) {
    isModuleApplicable = true;
  }

  return isModuleApplicable;
};
